import RequestService from '../requestService';
import {client} from '../../client';
import {ArkivSak} from '../../../models';

export default class ArkivSakService extends RequestService<ArkivSak,'arkivSak'> {constructor() {
        super('arkivSak');
    }

    createArkivsakWS = async (erFordelingssak: boolean) => client.post<ArkivSak>( `${this.serviceName}/wspluss/ny?erFordelingssak=${encodeURIComponent(erFordelingssak)}`, null );
}
